<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

import LuckyWheel from './components/luckywheel'
export default {
  name: "App",
  components: {
    LuckyWheel
  }
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  /* overflow: hidden; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue